import {IconButton, styled} from "@mui/material"

export type IconProps = {
    rotation?: number
}

export type ButtonProps = {
    direction: "left" | "right"
}

export const StyledIconButton = styled(IconButton, {shouldForwardProp: p => p !== "direction"})<ButtonProps>`
    position: absolute;
    ${({direction}) => `${direction === "left" ? "left" : "right"}: 0;`}
    height: 100%;
    background: ${({direction}) =>
        `linear-gradient(90deg, rgba(255, 255, 255, ${direction === "left" ? "1" : "0"}) ${
            direction === "left" ? "30%" : "0"
        }, rgba(255, 255, 255, ${direction === "left" ? "0" : "1"}) ${direction === "left" ? "100" : "70"}%)`};
    border-radius: 0;
    z-index: 1;
`

export const Icon = styled("img", {shouldForwardProp: p => p !== "rotation"})<IconProps>`
    transform: ${({rotation}) => `rotate(${rotation ?? 0}deg)`};
`
